// Platform-owned form validation (replaces native browser bubbles). Each check returns a message or null.
const EMAIL_RX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export const checks = {
  required: (v, msg) => (!v || !String(v).trim() ? msg : null),
  email: (v) => (!v || !v.trim() ? "Ingresá tu email" : !EMAIL_RX.test(v.trim()) ? "Revisá el email: parece incompleto (ej. nombre@dominio.com)" : null),
  password: (v) => (!v ? "Ingresá una contraseña"
    : v.length < 8 || !/[A-Za-z]/.test(v) || !/\d/.test(v) ? "La contraseña necesita al menos 8 caracteres, con letras y números" : null),
  match: (a, b) => (a !== b ? "Las contraseñas no coinciden" : null),
};

// Keeps only failing fields: { field: message }.
export const collect = (pairs) => Object.fromEntries(Object.entries(pairs).filter(([, m]) => m));
